<script lang="ts" module>
  import BaseCard from '@/ui/elements/card/BaseCard.svelte';
  import CardHeader from '@/ui/elements/card/CardHeader.svelte';

  import NumberPill from './helpers/NumberPill.svelte';

  export namespace AssistantHeader {
    export interface Props {
      title: string;
      value: number;
      loading?: boolean;
    }
  }
</script>

<script lang="ts">
  let { title, value, loading }: AssistantHeader.Props = $props();
</script>

<BaseCard class="relative">
  <CardHeader cardLabel={title}>
    <NumberPill {value} {loading}></NumberPill>
  </CardHeader>
</BaseCard>
